
























import { User } from "@/classes/TayehApi";
import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
    computed: {
        ...(mapGetters({USER: 'USER'}))
    }
})
export default class DashboardResetPassword extends Vue {
    old_password: string|null = null;
    new_password: string|null = null;
    repeat_new_password: string|null = null;
    USER!: any;
    can_send_code = true;
    loading = false;

    public get canSubmit () {
        return this.old_password&&this.new_password&&this.new_password===this.repeat_new_password&&this.new_password.length>=8
    }

    async resendVerification () {
        this.can_send_code = false;
        const user = await this.USER
        user?.mobile?User.sendMobileVerificationCode({mobile: user?.mobile}):User.sendEmailVerificationCode({email: user.email})
    }

    async changePassword () {
        if (!this.new_password||this.new_password!==this.repeat_new_password) return;
        if (this.new_password==this.old_password) return this.$message.error('رمز جدید نباید تکرار رمز قدیمی باشد.')
        this.loading = true;
        try {
            await User.resetPassword({
                old_password: this.old_password,
                new_password: this.new_password
            });
            this.$message({
                message: "رمز عبور شما با موفقیت ویرایش شد.",
                type: 'success'
            })
            this.$router.replace({name: 'user-shops'})
            this.old_password = this.new_password = this.repeat_new_password = null;
        } catch (err) {
            console.log(err);   
        }
        this.loading = false;
    }
}
